import React from "react";
import { pageStyles } from "../styles/appTheme";

type AppPageShellProps = {
  kicker?: string;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  maxWidth?: string | number;
};

export default function AppPageShell({
  kicker = "Ava",
  title,
  subtitle,
  children,
  maxWidth = "1180px",
}: AppPageShellProps) {
  return (
    <div style={pageStyles.page}>
      <div
        style={{
          ...pageStyles.shell,
          maxWidth,
        }}
      >
        <div style={pageStyles.topRow}>
          <div style={pageStyles.kicker}>{kicker}</div>
          <h1 style={pageStyles.title}>{title}</h1>
          {subtitle ? <p style={pageStyles.subtitle}>{subtitle}</p> : null}
        </div>

        {children}
      </div>
    </div>
  );
}
